export default __webpack_public_path__ + "static/media/strategyChi3.7d7b79ce.jpg";